import { Vendor } from '@/api/repository/vendorRepository.js'
import get from 'lodash-es/get'
const state = {
  vendor: {},
  settings: {},
  dataHomePage: [],
  ipData: {},
  headerMenu: [],
  footerMenu: [],
  viewData: []
}
const actions = {
  async fetchVendor({ commit }) {
    const res = await Vendor.getVendorIdFromOrigin()
    await commit('setVendor', res)
    return res
  },
  async getSettingsVendor({ commit, state }) {
    const res = await Vendor.getSettingsVendor(state.vendor)
    localStorage.setItem('facebookPageId', res.learn.facebookPageId)
    _updateTheme({ ...get(res, 'learn.themeConfig.themeData'), isAccessCourseDirectly: res.learn.isAccessCourseDirectly })
    commit('setSettings', res)
    return res
  },
  async fetchDataForHomePage({ commit, state }, { query }) {
    const res = await Vendor.fetchDataForHomePage(state.vendor.vendorId, query)
    commit('setDataHomePage', res)
    return res
  },
  async fetchRootVendor({ commit }, domain) {
    const res = await Vendor.featchRootVender(domain)
    commit('setHeaderMenu', res.settings.headerMenu || [])
    commit('setFooterMenu', res.settings.footerMenu || [])
    return res
  },
  async getDataCustomPage({ commit}, params) {
    const res = await Vendor.fetchDataCustomPages(params)
    const viewData = res.sort((a, b) => a.index - b.index)
    commit('setViewData', viewData)
    return viewData
  },
}
const mutations = {
  setVendor(state, vendor) {
    state.vendor = vendor
  },
  setSettings(state, settings) {
    state.settings = settings
  },
  setDataHomePage(state, dataHomePage) {
    state.dataHomePage = dataHomePage || []
  },
  setDataIP(state, ipData) {
    state.ipData = ipData
  },
  setHeaderMenu(state, data) {
    state.headerMenu = data
  },
  setFooterMenu(state, data) {
    state.footerMenu = data
  },
  setViewData(state, data) {
    state.viewData = data
  }
}
const getters = {
  getSettings(state) {
    return state.settings
  },
  getViewData(state) {
    return state.viewData
  },
  getViewAboutUs(state) {
    return get(state.settings, 'learn.themeConfig.aboutMe')
  },
  getViewPrivacyPolicy(state) {
    return get(state.settings, 'learn.themeConfig.privacyPolicy')
  },
  getViewRecruitment(state) {
    return get(state.settings, 'learn.themeConfig.recruitment')
  },
  getContact(state) {
    return get(state.settings, 'contact')
  },
  getSocialNetwork: state => {
    return get(state.settings, 'learn.socialNetwork')
  },
  getHeaderSetting(state) {
    const isHeaderMarket = get(state.settings, 'learn.isDisplayMarketHeader', false)
    return isHeaderMarket
  },
  getExceedWatchVideo: state => {
    return {
      countExceedWatchVideo: get(state.settings, 'learn.countExceedWatchVideo'),
      isCountExceedWatchVideo: get(state.settings, 'learn.isCountExceedWatchVideo')
    }
  },
  getHeaderNav(state) {
    return state.headerMenu || []
  },
  getFooterItem(state) {
    return state.footerMenu || []
  },
  getThemedata(state) {
    return get(state.settings, 'learn.themeConfig.themeData')
  },
  getDataHomePage(state) {
    return state.dataHomePage
  },
  getVendor(state) {
    return state.vendor
  },
  getThemeData(state) {
    return get(state.settings, 'learn.themeConfig.themeData')
  },
  getBankInfo(state) {
    return get(state.settings, 'bankInfo', {})
  },
  getDisplayProfile(state) {
    return get(state.settings, 'learn.isDisplayProfile')
  },
  getBaitNotification(state) {
    let result = {
      isNotificationBaited: get(state.settings, 'learn.isNotificationBaited', false),
      baitNotifications: get(state.settings, 'learn.baitNotifications', [])
    }
    return result
  },
  getCurrentLanguage: state => {
    return get(state.settings, 'learn.currentLanguage', 'vi')
  },
  getDisplayZoom(state) {
    return get(state.settings, 'learn.isDisplayZoom')
  },
  getIsDiableRegistration(state) {
    return get(state.settings, 'learn.isDisableRegistration')
  },
  getPermissionAllZoom: state => {
    return get(state.settings, 'learn.isPermissionAccessAllZoom')
  },
  getExternalScript: state => {
    return get(state.settings, 'learn.externalScript', [])
  },
  getIpDataForCountry: state => {
    return get(state.ipData, 'country', 'vietnam')
  },
  getIsDisplayCustomTopic: state => {
    return get(state.settings, 'learn.isDisplayCustomTopic')
  },
  getCustomTopic: state => {
    return get(state.settings, 'learn.customTopic', [])
  },
  getIsSaveZoom: state => {
    return get(state.settings, 'learn.isSaveZoom', false)
  },
  getIsDisplayWatermark: state => {
		return get(state.settings, 'learn.isDisplayWatermark', false)
	}
}

const _updateTheme = themeConfig => {
  const old = localStorage.getItem('iztech-theme')
  const newTheme = JSON.stringify(themeConfig)
  if (!old) {
    localStorage.setItem('iztech-theme', newTheme)
  }
  if (newTheme !== old) {
    localStorage.setItem('iztech-theme', newTheme)
    return window.location.reload()
  }
}

export default {
  state,
  actions,
  getters,
  mutations,
  namespaced: true
}
